import { roleHasPermission } from "@crewledger/shared/auth";
import { useAuth } from "@/features/auth/auth-provider";

export function useAuditPermissions() {
  const { user } = useAuth();
  const role = (user?.role ?? "EMPLOYEE") as Parameters<typeof roleHasPermission>[0];

  return {
    canRead: roleHasPermission(role, "audit:read"),
    isReadOnly: role === "AUDITOR" || role === "SITE_MANAGER",
    isSiteScoped: role === "SITE_MANAGER",
    role,
  };
}
